import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Scale } from "lucide-react";

const UPDATED = "November 2, 2026";

const SECTIONS = [
  {
    id: "disclaimer", title: "Not financial advice",
    body: [
      "CatalystCaddy is a research and journaling tool. Nothing on this site — risk scores, bundle detection, holder data, catalyst dates, AI takes or trending lists — is investment, financial, legal or tax advice, or a recommendation to buy or sell any token.",
      "Memecoins are extremely volatile and frequently go to zero. Data comes from third-party sources (DexScreener, Birdeye, Helius, GoPlus, RugCheck, X, public calendars and news feeds) and can be delayed, incomplete or wrong. The \"AI Take\" is an automated opinion generated from that data and can be mistaken. Always do your own research and never risk more than you can afford to lose.",
    ],
  },
  {
    id: "terms", title: "Terms of service",
    body: [
      "By using CatalystCaddy you agree to these terms. You must be at least 18 and legally allowed to use crypto-related services where you live.",
      "Pro is a subscription billed through Stripe at the price shown on the Pricing page. It renews automatically until cancelled; you can cancel any time from Account → Manage billing and keep access until the end of the paid period. Trials convert to paid unless cancelled before the trial ends. Lifetime codes are non-transferable.",
      "Don't abuse the service: no scraping, reselling data, reverse-engineering, or sharing one account across many people. We may suspend accounts that do. The service is provided \"as is\" without warranties; to the fullest extent allowed by law our liability is limited to the fees you paid us in the previous 3 months.",
      "We may change features or these terms; material changes will be announced in-app or by email.",
    ],
  },
  {
    id: "privacy", title: "Privacy",
    body: [
      "We store your email, username, password hash (or Google ID), subscription status, your journal trades, watchlist, starred catalysts, private events and any wallet addresses you choose to import. We do not sell personal data.",
      "Payments are processed by Stripe; we never see your card number. Wallet import reads public on-chain data only — we never ask you to connect a wallet or sign anything. Token lookups are sent to third-party data providers without your identity.",
      "Cookies are used for login sessions only. You can delete your account and data by emailing support; export of your journal is available on request.",
    ],
  },
];

export default function Legal() {
  const { hash } = useLocation();
  useEffect(() => { if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }); }, [hash]);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-8 sm:py-12" data-testid="legal-page">
      <h1 className="font-display text-2xl sm:text-3xl font-bold flex items-center gap-2"><Scale className="h-6 w-6 text-emerald-400" /> Legal</h1>
      <p className="text-slate-500 text-xs font-mono mt-1 mb-8">Last updated {UPDATED}</p>
      <div className="flex gap-3 mb-8 text-sm">
        {SECTIONS.map((s) => <a key={s.id} href={`#${s.id}`} className="text-emerald-400 hover:underline">{s.title}</a>)}
      </div>
      <div className="space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-24" data-testid={`legal-${s.id}`}>
            <h2 className="font-display text-lg font-bold mb-3">{s.title}</h2>
            <div className="space-y-3 text-sm text-slate-300 leading-relaxed">{s.body.map((p, i) => <p key={i}>{p}</p>)}</div>
          </section>
        ))}
      </div>
    </div>
  );
}
